module.exports = __webpack_public_path__ + "static/img/interest05.cb2d03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest05.png
// module id = GZ26
// module chunks = 0